import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../../context/AuthContext';
import { useScope } from '../../context/ScopeContext';
import { api } from '../../lib/api';

const today = () => new Date().toISOString().slice(0, 10);
const monthStart = () => `${today().slice(0, 7)}-01`;
const money = (value: unknown) => Number(value ?? 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export function DashboardPage() {
  const { user } = useAuth();
  const scope = useScope();
  const [from, setFrom] = useState(monthStart());
  const [to, setTo] = useState(today());
  const enabled = Boolean(scope.companyId);
  const overview = useQuery({
    queryKey: ['dashboard-overview', scope.companyId, scope.branchId, from, to],
    enabled,
    queryFn: () => {
      const params = new URLSearchParams({ companyId: scope.companyId, from, to });
      if (scope.branchId) params.set('branchId', scope.branchId);
      return api<any>(`/reporting/overview?${params}`);
    },
  });

  const data = overview.data ?? {};
  return <section>
    <div className="page-header"><div><h1>Dashboard</h1><p>Operational System V5 — management snapshot for the selected company and branch.</p></div></div>
    <div className="card dashboard-filter">
      <label>From<input type="date" value={from} onChange={event => setFrom(event.target.value)} /></label>
      <label>To<input type="date" value={to} onChange={event => setTo(event.target.value)} /></label>
      <div><strong>{scope.companies.find(item => item.id === scope.companyId)?.name ?? 'Choose company'}</strong><br /><small>{scope.branches.find(item => item.id === scope.branchId)?.name ?? 'All branches'}</small></div>
    </div>
    {!enabled && <p className="error">Choose a company to load dashboard totals.</p>}
    {overview.error && <p className="error">{(overview.error as Error).message}</p>}
    <div className="dashboard-kpis">
      <div className="dashboard-kpi"><small>Posted revenue</small><strong>{money(data.invoiced)} EGP</strong><span>{data.invoiceCount ?? 0} invoices</span></div>
      <div className="dashboard-kpi"><small>Collections</small><strong>{money(data.collected)} EGP</strong><span>{data.receiptCount ?? 0} receipts</span></div>
      <div className="dashboard-kpi"><small>Completed sessions</small><strong>{data.completedSessions ?? 0}</strong><span>Completed service sessions</span></div>
      <div className="dashboard-kpi"><small>Consumables issued</small><strong>{money(data.consumablesIssued)} EGP</strong><span>Inventory issue value</span></div>
    </div>
    <div className="grid three">
      <div className="card"><h3>User</h3><strong>{user?.displayName}</strong><p>{user?.email}</p></div>
      <div className="card"><h3>Access scope</h3><p>{scope.companyId ? 'Company selected' : 'No company selected'} · {scope.branchId ? 'Branch selected' : 'All branches'}</p></div>
      <div className="card"><h3>Permissions</h3><strong>{user?.permissions.length ?? 0}</strong><p>Granted permissions</p></div>
    </div>
  </section>;
}
